export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5926.5e16a1ba.jpg";